import { cloneDeep } from "common/utils/core";
import { useDtfStore } from "components/jiffy/vue-product-details-dtf/store";

// eslint-disable-next-line import/prefer-default-export
export class DtfPricesDecorator {
  dtfStore = useDtfStore();

  extraCharge = 0;

  updateCostInfo(data) {
    const newData = cloneDeep(data);
    const { cart_dates: cartDates, composition_dates: compositionDates } = newData;
    if (cartDates?.shipping_cost_info) {
      cartDates.shipping_cost_info.amount_until_free -= this.extraCharge;
      cartDates.shipping_cost_info.free = cartDates.shipping_cost_info.amount_until_free <= 0;
    }
    if (compositionDates?.shipping_cost_info) {
      compositionDates.shipping_cost_info.amount_until_free -= this.extraCharge;
      compositionDates.shipping_cost_info.free =
        compositionDates.shipping_cost_info.amount_until_free <= 0;
    }
    return newData;
  }

  subscribe() {
    this.dtfStore.$subscribe((_, { summary }) => {
      this.extraCharge = 0; // Reset extra charge on each state change
      Object.values(summary.enhancements || {}).forEach(enhancement => {
        this.extraCharge += parseFloat(enhancement.totalPrice) || 0;
      });
    });
  }
}
